import * as Actioncable from 'actioncable'
import cable from '../../../cable'
import config from '../../../config'

const debugLog = (msg: string): void => config.DEV && console.log(msg)

export function newConnection(channelId: number, onReceive: (obj: any) => void): Actioncable.Channel {
  const channelParams: ActionCable.ChannelNameWithParams = {
    channel: 'ListingUpdateChannel',
    channel_id: channelId,
    organization_id: config.user.organization.id
  }

  return cable.subscriptions.create(channelParams, {
    connected() {
      debugLog(`[ListingUpdateChannel] connected`)
    },
    disconnected() {
      debugLog(`[ListingUpdateChannel] disconnected`)
    },
    received(data) {
      debugLog(`[ListingUpdateChannel] received ${JSON.stringify(data)}`)

      onReceive(data)
    }
  })
}

export function updateFromProduct(state: any, data: any) {
  return {
    data: state.data.map(currListing => {
      if (currListing.productId === data.product_id) {
        // TODO: finish this fix after merge, const camelized = Object.keys(data).reduce((acc, key) => ({ ...acc, [camelCase(key)]: data[key] }), {})
        return {
          ...currListing,
          ...data
        }
      }

      return currListing
    })
  }
}
